exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SharingOptionsButton__sharingButton___dxUjS {\n  font-weight: 500;\n  font-size: 16px;\n  cursor: pointer;\n  height: 64px;\n  width: calc(50% - 10px);\n  border-radius: 8px;\n  padding: 19px 0;\n  text-align: center; }\n\n.SharingOptionsButton__text___Zie_k {\n  vertical-align: middle; }\n", ""]);

// exports
exports.locals = {
	"sharingButton": "SharingOptionsButton__sharingButton___dxUjS",
	"text": "SharingOptionsButton__text___Zie_k"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdDetailsPage/AdDetailsPageWeb/styles/SharingOptionsButton.scss
// module id = 4589
// module chunks = 6